<!-- for veevalidate errors -->
<template>
  <v-messages v-if="value"
              :value="errors"
              color="error"
              style="margin-top: -23px;"
              ></v-messages>
</template>
<script>
export default {
  name: 'error-messages',

  props: {
    value: {
      type: [Object, String, Array]
    }
  },

  computed: {
    errors () {
      const { $bi, value, $errorMsgHandler } = this
      let v = value
      if ($bi.isObject(value)) {
        v = $errorMsgHandler(value)
      } else if ($bi.isString(value)) {
        v = [value]
      }
      return v
    }
  }
}
</script>
